import { Block } from "@business-finland/wif-ui-lib";
import { PageHeader } from "@business-finland/wif-ui-lib/dist/PageHeader";
import { useEffect, useRef } from "react";

import buildGetStaticProps from "../service/static-props-api";

export const getStaticProps = buildGetStaticProps("Cookies", "/cookies");

export default function Cookies() {
  return (
    <>
      <PageHeader
        heading="Cookie Policy"
        leadText="Find information on how workinfinland.com uses cookies"
        backgroundColor="lightBlue"
      />
      <Block>
        <Block.Content>
          <CookieDeclaration />
        </Block.Content>
      </Block>
    </>
  );
}

function CookieDeclaration() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.id = "CookieDeclaration";
      script.src =
        "https://consent.cookiebot.com/f68f035c-7edf-41b7-a7d3-9f0b0f96401f/cd.js";

      ref.current.appendChild(script);
    }
  }, [ref]);

  return <div id="CookieDeclarationCont" ref={ref} />;
}
